import { logout } from "@onmo/auth";
import { cache } from "@onmo/graphql";
import { clearActivationCode } from "./storage";
import { clearPendingSurvey } from "./survey";

let isLoggingOut = false;

export const forceLogout = async () => {
  if (isLoggingOut) return;
  isLoggingOut = true;
  try {
    await logout(true);
    await cache.reset();
    clearActivationCode();
    clearPendingSurvey();
    sessionStorage.removeItem("prev-recents-played");
  } catch (error) {
    console.error(error);
  } finally {
    isLoggingOut = false;
  }
};
